import React, { useState } from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { motion, AnimatePresence } from "framer-motion"
import { X } from "react-feather"
import logo from "../images/lte-impianti-logo.svg"
import logoWhite from "../images/lte-impianti-logo-bianco.svg"
import iconsMenu from "../images/icons/menu.svg"
import User from "../components/icons/user"
import DesignTokens from "./designTokens"
import PrimaryMenu from "./primaryMenu"

const Nav = ({theme}) => {
  const [showMenu, setShowMenu] = useState(false)
  return (
    <nav>
      <StyledMenu theme={theme}>
        <Link to="/">
          <img src={logoWhite} alt="LTE Impianti Logo" />
        </Link>
        <div>
          <Icon
            href="http://185.184.139.206:8181/#/logon"
            target="blank"
            rel="noopener nofollow"
          >
            <User color={DesignTokens.colors.white} />
          </Icon>
          <Menu
            role="button"
            tabIndex={0}
            onClick={() => setShowMenu(!showMenu)}
            onKeyDown={() => setShowMenu(!showMenu)}
          >
            <img src={iconsMenu} alt="Menu" />
          </Menu>
        </div>
      </StyledMenu>

      <AnimatePresence>
        {showMenu && (
          <StyledOverlay
            initial={{ opacity: 0, scale: 1.2 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.15 }}
            exit={{ opacity: 0 }}
          >
            <header>
              <X size={32} onClick={() => setShowMenu(false)} />
            </header>
            <PrimaryMenu />
          </StyledOverlay>
        )}
      </AnimatePresence>
    </nav>
  )
}

const Icon = styled.a`
  background: ${DesignTokens.colors.secondary[500]};
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 70px;
`

const Menu = styled.div`
  display: flex;
  border-left: 1px solid ${DesignTokens.colors.white};
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 70px;
  background: ${DesignTokens.colors.secondary[500]};
`

const StyledMenu = styled.div`
  padding: 0 0 0 ${DesignTokens.spacing[3]};
  height: 70px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: ${props => props.theme === "transparent" ? "transparent" : DesignTokens.colors.primary[500]};
  & > div {
    display: flex;
    height: 100%;
  }
`

const StyledOverlay = styled(motion.div)`
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  color: ${DesignTokens.colors.white};
  background: ${DesignTokens.colors.primary[500]};
  z-index: 10;
  overflow-y: scroll;
  header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 70px;
    text-align: right;
    padding: 0 1.2rem;
  }
  & > ul {
    padding: 0;
    margin: 0;
    list-style-type: none;
    display: flex;
    flex-direction: column;
    & > li {
      font-size: ${DesignTokens.fontSizes[7]};
      padding: ${DesignTokens.spacing[3]};
      text-align: center;
      margin: 0;
      & > a {
        font-family: "Yantramanav";
        color: ${DesignTokens.colors.white};
        text-decoration: none;
      }
    }
  }
`

export default Nav
